<template>
  <v-carousel :show-arrows="false" cycle>
    <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
      <v-row
        :align="item.align"
        :justify="item.justify"
        class="lightbox white--text ma-8 pa-2 fill-height"
      >
        <v-col class="ma-4 backcolorgrey" col="12" sm="8" md="6" lg="4">
          <div class="subheading display-2"><span class="fontvn" v-if="item.title === 'Violent Noise'">{{
                item.title
              }}</span>
              <span v-if="item.title !== 'Violent Noise'">{{
                item.title
              }}</span></div>
          <div class="body-1">{{ item.body }}</div>
        </v-col>
      </v-row>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
// @ is an alias to /src

const image1 = require("@/assets/images/carousel/show.jpg");
const image2 = require("@/assets/images/carousel/drums.jpg");
const image3 = require("@/assets/images/carousel/artist-back-view.jpg");
const image4 = require("@/assets/images/carousel/people.jpg");

export default {
  components: {},
  data() {
    return {
      items: [
        {
          //src: require("@/assets/images/carousel/audience-celebration.jpg"),
          src: image1,
          title: "Violent Noise",
          body: "O melhor do Rock.",
          align: "center",
          justify: "end"
        },
        {
          //src: require("@/assets/images/carousel/audio-cassette.jpg"),
          src: image2,
          title: "Blog",
          body: "Visite nosso blog",
          align: "start",
          justify: "start"
        },
        {
          //src: require("@/assets/images/carousel/band-bright.jpg"),
          src: image3,
          title: "Facebook",
          body: "Acompanhe as noticias no Facebook",
          align: "center",
          justify: "end"
        },
        {
          //src: require("@/assets/images/carousel/black-and-white.jpg"),
          src: image4,
          title: "Patrocinio",
          body: "Seja nosso patrocinador",
          align: "center",
          justify: "start"
        }
      ]
    };
  }
};
</script>

<style scoped>
.fontvn {
  font-family: "Fontdiner Swanky", serif;
}

.backcolorgrey {
  background-color: rgba(37, 47, 42, 0.3);
}
</style>
